import React, { useState } from "react";
import { ModalWrapper } from "../ModalWrapper";
import { SignalReport } from "./SignalReport";
import ConfirmationDialog from "../ConfirmationDialog/ConfirmationDialog";
import { showErrorToast } from "../../helpers";

const ACTIONS_REQUIRING_CONFIRMATION = ["suspect paper mill"];

export const SignalReportModal = ({
  onClose,
  contentData,
  dupSubData,
  visibleSection,
  setTriggerOrMatchStatus,
  setSubmissionStatus,
  fetchData,
}) => {
  const isOpen = !!contentData || !!dupSubData;

  const [confirmationDialog, setConfirmationDialog] = useState({
    isOpen: false,
    actionType: null,
    actionContext: null,
  });

  const updateDupSubStatus = async (_, submissionStatus, additionalParams) => {
    if (!dupSubData || !setTriggerOrMatchStatus) return;
    const { match_id, persistent_id } = dupSubData;
    try {
      await setTriggerOrMatchStatus(match_id, persistent_id, submissionStatus, additionalParams);
      fetchData();
    } catch {
      showErrorToast();
    }
  };

  const updateAmbientScreeningStatus = async (_, submissionStatus, additionalParams = {}) => {
    if (!contentData) return;
    const { id } = contentData;
    try {
      await setSubmissionStatus(id, submissionStatus, additionalParams);
      fetchData();
    } catch {
      showErrorToast();
    }
  };

  const handleActionSelect = (index, status) => {
    if (ACTIONS_REQUIRING_CONFIRMATION.includes(status)) {
      setConfirmationDialog({
        isOpen: true,
        actionType: status,
        actionContext: { index, value: status },
      });
      return;
    }
    updateAmbientScreeningStatus(index, status);
  };

  const handleConfirmationApply = (options) => {
    const { index, value } = confirmationDialog.actionContext;

    const fullParams = {
      ...(options.addToSignalcheck && {
        signalCheck: {
          user: { comment: options.comment || "" },
          manuscript: {
            title: contentData?.title,
            manuscript_id: contentData?.manuscript_id,
            publisher_id: contentData?.publisher_id,
            user_id: contentData?.user_id,
          },
        },
      }),
    };

    updateAmbientScreeningStatus(index, value, fullParams);
    setConfirmationDialog({ isOpen: false, actionType: null, actionContext: null });
  };

  const handleConfirmationClose = () => {
    setConfirmationDialog({ isOpen: false, actionType: null, actionContext: null });
  };

  return (
    <>
      <ModalWrapper title={"Signal(s) report"} isOpen={isOpen} onClose={onClose}>
        <SignalReport
          contentData={contentData}
          dupSubData={dupSubData}
          visibleSection={visibleSection}
          updateDupSubStatus={updateDupSubStatus}
          updateAmbientScreeningStatus={updateAmbientScreeningStatus}
          onAmbientScreeningActionSelect={handleActionSelect}
        />
      </ModalWrapper>
      <ConfirmationDialog
        isOpen={confirmationDialog.isOpen}
        actionType={confirmationDialog.actionType}
        onClose={handleConfirmationClose}
        onApply={handleConfirmationApply}
      />
    </>
  );
};
